module.exports = __webpack_public_path__ + "static/img/application4-2.5dd9cd2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/application/application4-2.jpg
// module id = Asz4
// module chunks = 0